<template>
  <div class="feedback-box">
    <span class="hover-link text-small" @click="open">
      <fa-icon :icon="['fal', 'lightbulb']" />
      {{ label }}
    </span>

    <dx-modal
      id="modal-feedback"
      title="Está faltando algo?"
      size="md"
      v-model="show"
      v-if="show"
    >
      <div class="form-group">
        <label class="form-label" for="feedback-type">Assunto</label>
        <select id="feedback-type" class="form-select" v-model="form.type">
          <option v-for="option in subjects" :value="option.value" :key="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>
      <div class="form-group" :class="{'has-error': $v.form.description.$error}">
        <label class="form-label" for="feedback-description">Descrição</label>
        <textarea
          id="feedback-description"
          class="form-input"
          rows="5"
          v-model="form.description"
          :placeholder="placeholder"
          @blur="$v.form.description.$touch()"
        />
        <template v-if="$v.form.description.$error">
          <div class="form-input-hint">Campo obrigatório</div>
        </template>
      </div>
      <div class="text-small text-gray">
        Enviamos junto o nome do profissional e da clínica para que a nossa equipe
        possa retornar o contato. Não informe dados do paciente.
      </div>
      <template slot="footer">
        <button
          class="btn btn-primary btn-icon btn-icon-left mr-1"
          :class="{loading: saving}"
          :disabled="saving"
          @click="save"
        ><fa-icon :icon="['fal', 'paper-plane']" />Enviar</button>
        <button class="btn" @click="close">Sair</button>
      </template>
    </dx-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

const MISSING_ITEM = 'missing-item';
const SUGGESTION = 'suggestion';
const SUGGESTION_LABEL = 'Tenho uma sugestão de melhoria';

export default {
  props: {
    context: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Está faltando algo ou tem uma sugestão? Fale com a gente',
    },
    missingLabel: {
      type: String,
      default: 'Está faltando algum cadastro',
    },
    placeholder: {
      type: String,
      default: 'Descreva o que está faltando ou o que podemos melhorar...',
    },
    options: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      saving: false,
      form: this.blankForm(),
    };
  },
  computed: {
    subjects() {
      if (this.options && this.options.length > 0) {
        return this.options;
      }

      return [
        { value: MISSING_ITEM, label: this.missingLabel },
        { value: SUGGESTION, label: SUGGESTION_LABEL },
      ];
    },
  },
  validations() {
    return {
      form: {
        description: { required },
      },
    };
  },
  methods: {
    open() {
      this.form = this.blankForm();
      this.$v.$reset();
      this.show = true;
    },
    close() {
      this.show = false;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.saving = true;
      this.$httpX.post('/customer/feedbacks', {
        type: this.form.type,
        description: this.form.description,
        context: this.context,
      })
        .then(() => {
          this.$toast.show('Obrigado! Sua mensagem foi enviada para a nossa equipe.');
          this.close();
        })
        .catch(this.$toast.error)
        .then(() => {
          this.saving = false;
        });
    },
    blankForm() {
      const [first] = this.options || [];

      return {
        type: first ? first.value : MISSING_ITEM,
        description: '',
      };
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';
.feedback-box {
  margin-top: $layout-spacing;
  text-align: center;
  svg {
    margin-right: $layout-spacing-sm;
  }
}
</style>
